import { scrollToElement, OptionCardGroup, OptionCard, OptionCardContent } from 'telia-front-react';
import { runInAction } from 'mobx';
import React from 'react';

import { inject, observer } from 'mobx-react';
import CmsDataStore from '../stores/CmsDataStore';
import { Item } from './packet/types';
import Product from './product/Product';

interface ProductCarouselProps {
  label: React.ReactNode;
  dataField: string;
  packageDataField: string;
  items: Item[];
  cmsDataStore?: CmsDataStore;
  nextStepId?: string;
}

interface ProductCarouselState {
  selectedItem: Item | null;
}

@observer
class ProductCarousel extends React.Component<ProductCarouselProps, ProductCarouselState> {
  public static defaultProps: Partial<ProductCarouselProps> = {
    dataField: 'selectedProduct',
    packageDataField: 'selectedPackage'
  };

  public constructor(props: ProductCarouselProps) {
    super(props);
    this.state = { selectedItem: null };
  }

  public componentDidMount() {
    const { cmsDataStore, dataField } = this.props;
    const selectedItem = cmsDataStore.getData(dataField);
    if (selectedItem) {
      this.setState({ selectedItem });
    }
  }

  private handleProductItemClick(item: Item, value: string) {
    const { cmsDataStore, dataField, packageDataField, nextStepId } = this.props;
    runInAction(() => {
      cmsDataStore.setData(`${dataField}Name`, value);
      cmsDataStore.setData(dataField, item);
    });
    const selectedPacket = cmsDataStore.getData(packageDataField);
    if (selectedPacket && item.type && selectedPacket.type !== item.type) {
      runInAction(() => {
        cmsDataStore.setData(packageDataField, null);
        cmsDataStore.setData(`${packageDataField}Name`, null);
      });
    }
    this.setState({ selectedItem: item });

    if (nextStepId) {
      scrollToElement(nextStepId);
    }
  }

  private mapItem(item: Item) {
    const value = `${item.brand} ${item.name}`;

    return (
      <OptionCard key={value} id={value} value={value} inputType="radio" labelText={value} onChange={() => this.handleProductItemClick(item, value)}>
        <OptionCardContent tagTop={item.tag ?? true}>
          <Product {...item} />
        </OptionCardContent>
      </OptionCard>
    );
  }

  private get currentValue() {
    const selectedItem = this.state.selectedItem;

    return selectedItem ? `${selectedItem.brand} ${selectedItem.name}` : null;
  }

  public render() {
    const { dataField, label } = this.props;

    return (
      <OptionCardGroup
        label={label}
        inputType="radio"
        value={this.currentValue}
        // Force to be controlled, value setting is handled in OptionCard onChange.
        onChange={() => {}}
        name={dataField}
        gridColumn={{
          width: ['xs-12', 'sm-6', 'md-3']
        }}
      >
        {this.props.items.map((item: Item) => this.mapItem(item))}
      </OptionCardGroup>
    );
  }
}

export default inject('cmsDataStore')(ProductCarousel);
